/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import 'components/Modal/createModal.css';
import { useSelector } from 'react-redux';
import { useCommonInits } from 'hooks/useCommonInits';
import { getGroupsbyId,getRequestByID } from 'redux/datasource/dataSourceSlice';
import { getUser } from 'redux/auth/authSlice';
import { updatePanelContent } from 'redux/panels/panelsSlice';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import {
    Typography,
    TextField,   
    Modal,
   Backdrop,
    Box,
    Grid,
} from '@mui/material';
import { AppButton } from 'app/components/shared/AppButton';
import { generateHash } from 'utils/encryptDecrypt';

const style = {
    position: 'absolute',
    top: '30%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.default',
    border: '1px solid',
    boxShadow: 24,
    p: 2,
};

export default function ExecuteConfirmationModal({ isOpen, handleCloseModal ,handleControlPassword, handleConfirmation}) {
    const [open, setOpen] = useState(false);
    const { dispatch } = useCommonInits();

    const [reqName, setReqName] = useState('');
    const [groupId, setGroupId] = useState('');
    const [groupName, setGroupName] = useState('');
    const [execute, setExecute] = useState('');
    const [newPrice, setNewPrice] = useState();
    const [cPass,setCPass] = useState('');
    const [oldPrice, setOldPrice] = useState();
    const [errorMsg , setErrorMsg] = useState(false);
    const group_Name =useSelector(getGroupsbyId);
    const requestById = useSelector(getRequestByID)
    const user = useSelector(getUser);

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

     useEffect(()=>{
        if(requestById){
            handleConfirmation;
         setReqName(requestById.price_request_name);
         setOldPrice(requestById.old_price);
         setNewPrice(requestById.price);
         setExecute(requestById.executed);
        }
      
     },[requestById])
 
     useEffect(()=>{
         setGroupId(group_Name._id);
         setGroupName(group_Name.name);
     },[])
 
      const handleClose = () => {
        setOpen(false);
        handleCloseModal();
    };

    const handleDataChange = () => {
        dispatch(
            updatePanelContent({
                cPass 
           }),
        );
    };

  const submitPassword=()=>{
        handleControlPassword(generateHash(cPass));
  }

    return (
        <div>
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Box sx={style}>
                    <Grid container>
                        <Grid
                            item
                            sx={{
                                position: 'absolute',
                                right: '5px',
                                top: '5px',
                            }}
                        >
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>

                    <Typography variant="h5" style={{ marginBottom: 10,marginTop:10 }}>
                   Enter Control Password
                </Typography>
                <TextField
                    required
                    hiddenLabel
                    fullWidth
                    type='password'
                    value={cPass}
                    variant="outlined"
                    size="small"
                    label='Control Password'
                    onChange={e => setCPass(e.target.value)}
                    onBlur={handleDataChange}
                />
                {errorMsg  ?(     <label
                        style={{
                            color: 'red',
                            fontSize: 20,
                            marginBottom: '10px',
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                      Control Password does not match
                    </label>
                ) : (
                    ''
                )}
       <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: '20px',
                    }}
                >
                    <AppButton variant='outlined' action={handleClose}>
                        Cancel
                    </AppButton>{' '}
                    &nbsp; &nbsp; &nbsp;
                    <AppButton
                        variant='outlined'
                        action={submitPassword}
                    >
                        Submit
                    </AppButton>
                </div>
                </Box>
            </Modal>
        </div>
    );
}


const styles = {
    unitsSelect: {
        width: 400,
        marginRight: 2,
        marginBotton:10,
        color: 'white',
    },
   
};